<template>
  <div>
    <!-- Exhibit Logo -->
    <div class="exhibit-logo" v-if="exhibitLogo">
      <img :src="exhibitLogo" alt="Exhibit Logo" />
    </div>

    <div>
      <!-- Address -->
      <div class="contact-item" v-if="fullAddress">
        <h4>Address:</h4>
        <i class="fa-regular fa-map-marker"></i> {{ fullAddress }}
      </div>

      <!-- Email -->
      <div class="contact-item" v-if="email">
        <h4>Email:</h4>
        <i class="fa-regular fa-envelope"></i>
        <a :href="`mailto:${email}`" target="_blank">
          {{ email }}
        </a>
      </div>

      <!-- Phone -->
      <div class="contact-item" v-if="phone">
        <h4>Phone:</h4>
        <i class="fa-regular fa-mobile"></i>
        <a :href="`tel:${phone}`" target="_blank">
          {{ phone }}
        </a>
      </div>

      <!-- Website -->
      <div class="contact-item" v-if="website">
        <h4>Website:</h4>
        <i class="fa-regular fa-globe"></i>
        <a :href="website" target="_blank">
          {{ website }}
        </a>
      </div>
    </div>

    <div class="booth-socials" v-if="hasSocials">
      <!-- Facebook -->
      <a
        v-if="facebookLink"
        :href="facebookLink"
        target="_blank"
        rel="noopener noreferrer"
        class="social-item"
      >
       <i class="fa-brands fa-square-facebook"></i>
      </a>

      <!-- X-Twitter -->
      <a
        v-if="twitterLink"
        :href="twitterLink"
        target="_blank"
        rel="noopener noreferrer"
        class="social-item"
      >
        <i class="fa-brands fa-square-x-twitter"></i>
      </a>

      <!-- Linked-In -->
      <a
        v-if="linkedInLink"
        :href="linkedInLink"
        target="_blank"
        rel="noopener noreferrer"
        class="social-item"
      >
        <i class="fa-brands fa-linkedin"></i>
      </a>

      <!-- Youtube -->
      <a
        v-if="youtubeLink"
        :href="youtubeLink"
        target="_blank"
        rel="noopener noreferrer"
        class="social-item"
      >
        <i class="fa-brands fa-square-youtube"></i>
      </a>
    </div>

    <div v-show="email" class="mb-15">
      <c-button
        fill
        uppercase
        theme="primary"
        icon="fa-envelope"
        @click="onOpenSendMeInformationModal()"
      >Send Me Information</c-button>
    </div>

    <!-- if only 1 giveaway -->
    <div v-if="giveaways && giveaways.length === 1" class="mb-15">
      <div class="giveaway-logo" v-if="giveaways[0].image_url">
        <img :src="giveaways[0].image_url" alt="Giveaway Logo" />
      </div>

      <div class="giveaway-description" v-if="giveaways[0].description" v-html="giveaways[0].description"></div>

      <!-- Give Away Button -->
      <c-button
        v-if="!giveaways[0].is_registered"
        fill
        uppercase
        theme="primary"
        icon="fa-gift-card"
        @click="enterToGiveAway(0)"
        :show-indicator="giveaways[0].loading"
        :disabled="!isAttendee"
      >Enter {{ !isAttendee ? '*' : '' }}</c-button>

      <!-- Registered Button -->
      <c-button
        v-if="giveaways[0].is_registered"
        fill
        uppercase
        theme="success"
        icon="fa-circle-check"
        disabled
      >Registered</c-button>
    </div>

    <!-- if more than 1 giveaway -->
    <div v-if="giveaways && giveaways?.length > 1" class="mb-15">
      <c-button
        fill
        uppercase
        :theme="`${isFullRegisteredToGiveaways ? 'success' : 'primary'}`"
        :icon="`${isFullRegisteredToGiveaways ? 'fa-circle-check' : 'fa-gift-card'}`"
        @click="onOpenGiveawaysModal()"
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Giveaways &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</c-button>
    </div>

    <!-- Send Me Information Dialog -->
    <send-me-information-modal
      :show-modal.sync="showSendMeInformationModal"
    />

    <!-- Giveaways Dialog -->
    <giveaways-modal
      :show-modal.sync="showGiveawaysModal"
      :is-attendee="isAttendee"
      :giveaways="giveaways"
      :enterToGiveAway="enterToGiveAway"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SendMeInformationModal from "./send-me-information-modal";
import GiveawaysModal from './giveaways-modal.vue'

export default {
  components: {
    GiveawaysModal,
    SendMeInformationModal
  },
  mounted() {},
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      sponsorId: this.$route.params.sponsorId,

      showSendMeInformationModal: false,
      showGiveawaysModal: false,

      submitLoading: false
    }
  },
  computed: {
    ...mapGetters('boothStore', [
      'exhibitLogo',
      'isAttendee',
      'fullAddress',
      'giveaways',
      'phone',
      'email',
      'website',
      'hasSocials',
      'facebookLink',
      'linkedInLink',
      'twitterLink',
      'youtubeLink',
      'isFullRegisteredToGiveaways'
    ]),
  },
  methods: {
    onOpenSendMeInformationModal() {
      this.showSendMeInformationModal = true;
    },

    onOpenGiveawaysModal() {
      this.showGiveawaysModal = true;
    },

    enterToGiveAway(index) {
      const data = {
        id: this.giveaways[index].id
      };

      this.giveaways[index].loading = true;

      this.$store.dispatch("boothStore/enterToGiveAway", { attendeeId: this.attendeeId, data})
        .then(status => {
          //TODO check if it's work
          if (status === 200) {
            this.giveaways[index].is_registered = 1;
          }

          this.giveaways[index].loading = false;

          //TODO: check if it's work
          this.$store.commit('boothStore/updateGiveaways', this.giveaways);
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.exhibit-logo {
  max-width: 350px;
  margin-bottom: 15px;
}
.exhibit-logo img {
  width: 100%;
  border-radius: var(--attendee-card-border-radius);
}

.contact-item {
  margin-bottom: 15px;
}

.social-item {
  display: inline-block;
  transition: color 0.3s;
  margin-right: 10px;
  font-size: 32px;
}

.booth-socials {
  margin-bottom: 15px;
}

.giveaway-logo {
  max-width: 210px;
  margin-bottom: 15px;
}

.giveaway-logo img {
  width: 100%;
}

.giveaway-description {
  white-space: pre-wrap;
  margin-bottom: 15px;
}

.mb-15 {
  margin-bottom: 15px;
}

@media (max-width: 959px) {
  .exhibit-logo {
    margin: 20px 0;
    max-width: 200px;
  }

  .giveaway-logo {
    margin: 0 auto;
  }
}
</style>
